<template>
  <v-toolbar id="core-toolbar" flat prominent style="background: #eee; margin-top: -10px;">
    <div class="v-toolbar-title">
      <v-toolbar-title class="tertiary--text font-weight-light">
        <v-btn v-if="responsive" class="default v-btn--simple" dark icon @click.stop="onClickBtn">
          <v-icon>mdi-view-list</v-icon>
        </v-btn>
        {{ title }}
      </v-toolbar-title>
    </div>

    <v-spacer />


    <v-toolbar-items>
      <v-flex align-center layout py-2>
        <router-link v-ripple class="toolbar-items" to="/">
          <v-icon color="tertiary">mdi-view-dashboard</v-icon>
        </router-link>

        <v-menu bottom left content-class="dropdown-menu" offset-y transition="slide-y-transition">
          <div slot="activator" class="toolbar-items">
            <v-icon color="tertiary">mdi-account</v-icon>
          </div>
          <v-card>
            <v-list dense>
              <v-list-tile @click="dialog2 = true">
                <v-list-tile-title>修改密码</v-list-tile-title>
              </v-list-tile>


              <v-list-tile @click="logout()">
                <v-list-tile-title>退出登录</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>

      </v-flex>
    </v-toolbar-items>
    <v-dialog v-model="dialog2" persistent max-width="600px">

      <v-card>
        <v-card-title>
          <span class="text-h5">修改密码</span>
        </v-card-title>
        <v-card-text>
          <v-container>

            <v-flex xs12 md6>
              <v-text-field type="password" label="请输入旧密码" v-model="currentData.oldpwd"></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field type="password" label="请输入新密码" v-model="currentData.newpwd"></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field type="password" label="再次输入新密码" v-model="currentData.checkpwd"></v-text-field>
            </v-flex>



          </v-container>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog2 = false">
            关闭
          </v-btn>
          <v-btn color="blue darken-1" text @click="doChange">
            提交
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-toolbar>
</template>

<script>

import {
  mapMutations
} from 'vuex'

export default {
  data: () => ({
    dialog2: false,
    userInfo: JSON.parse(sessionStorage.getItem('userInfo')),
    currentData: {},
    notifications: [
      'Mike, John responded to your email',
      'You have 5 new tasks',
      'You\'re now a friend with Andrew',
      'Another Notification',
      'Another One'
    ],
    title: null,
    responsive: false,
    responsiveInput: false
  }),

  watch: {
    '$route'(val) {
      this.title = val.name
    }
  },

  mounted() {
    this.onResponsiveInverted()

    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },

  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onClickBtn() {
      this.setDrawer(!this.$store.state.app.drawer)
    },
    async doChange() {
      if (!this.currentData.oldpwd || !this.currentData.oldpwd || !this.currentData.oldpwd) {
        this.$message({
          message: '填写的数据不能为空',
          type: "warning"
        })
        return
      }
      const res = await this.$post('admin/changePwd', this.currentData)
      if (res.errno === 0) {
        this.$message({
          message: '修改成功',
          type: "success"
        })
        this.logout()
      }

    },
    onClick() {
      //
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true
        this.responsiveInput = false
      } else {
        this.responsive = false
        this.responsiveInput = true
      }
    },
    //推出登录
    logout() {
      sessionStorage.removeItem('admin_name');
      sessionStorage.removeItem('admin_pwd');
      sessionStorage.removeItem('uid');
      this.$router.push({ path: '/login' })
    }
  }
}
</script>

<style>
#core-toolbar a {
  text-decoration: none;
}
</style>
